import { combineReducers } from "redux";
import common from './common'
const root = combineReducers({ common });

export default root;